export const listPublicVacancies = /* GraphQL */ `
  query ListVacancies($filter: ModelVacancyFilterInput, $limit: Int, $nextToken: String) {
    listVacancies(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        title
        location
        employment
        summary
        description
      }
      nextToken
    }
  }
`
